var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSeats3Mono(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 14,
    height: 10,
    rx: 5,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.077 7.413h.703c.274 0 .5-.047.679-.142a.923.923 0 00.405-.39c.088-.166.132-.357.132-.571 0-.225-.04-.417-.122-.577a.824.824 0 00-.361-.376c-.16-.087-.363-.131-.61-.131-.209 0-.398.042-.567.127a.962.962 0 00-.396.351.961.961 0 00-.146.537H5.612c0-.377.1-.713.298-1.006.199-.293.469-.522.81-.688.346-.17.733-.254 1.163-.254.459 0 .86.076 1.201.23.345.15.614.374.806.673.192.3.288.67.288 1.114 0 .201-.048.406-.142.615a1.786 1.786 0 01-.42.571c-.185.17-.416.308-.693.415a2.722 2.722 0 01-.962.156h-.884v-.654zm0 .918v-.644h.884c.417 0 .771.048 1.064.146.297.098.537.233.723.405.186.17.32.363.405.581.088.218.132.45.132.694 0 .332-.06.628-.18.888a1.804 1.804 0 01-.503.655 2.244 2.244 0 01-.767.405 3.14 3.14 0 01-.947.137c-.306 0-.6-.043-.88-.127-.28-.085-.53-.21-.751-.376a1.864 1.864 0 01-.528-.63 1.94 1.94 0 01-.19-.88h1.177c0 .213.049.4.146.563.101.159.241.284.42.375.183.092.39.137.625.137.248 0 .46-.044.64-.132a.916.916 0 00.41-.39 1.25 1.25 0 00.147-.625c0-.277-.054-.502-.162-.674a.948.948 0 00-.459-.381 1.784 1.784 0 00-.703-.127h-.703z",
    fill: "#fff"
  })));
}
SvgPokerSeats3Mono.displayName = 'PokerSeats3Mono';
export default SvgPokerSeats3Mono;